import {getArchetypeProfile} from "./archetypes";
import {getBotStrategy} from "./botStrategyStore";
import {getBotBonusProfile} from "../getBotBonusProfile";
import {selectGameType, selectRound} from "../../../redux/reducers/sharedStateReducer/selectors";
import {isBonusArmyPhase} from "../../../configs/botBonusBehavior";

/**
 * Профиль поведения бота: его архетип (см. archetypes.js), усиленный надбавками
 * за экономический бонус, если бот с ним играет (см. getBotBonusProfile).
 *
 * Единая точка получения профиля для всех фаз: надбавка обязана действовать
 * везде, где архетип влияет на решения, — иначе бот стал бы агрессивнее в бою,
 * но не в строительстве или найме.
 *
 * Волна 33 («сильные города», bonusProfile.strongCities): в армейской фазе
 * (первые 2/3 партии) бонусный бот вкладывается в армию и давит ближайшего
 * противника независимо от случайно выпавшего архетипа — стартовый DEFENSIVE
 * иначе резал бы чужие кварталы радиусом экспансии и жадностью до захвата 0.5:
 *  - expansionRadius снимается (цели и стройка не ограничены домом);
 *  - captureEagerness не ниже единицы (потом обычный множитель бонуса);
 *  - ключевые точки дешевле — новые города не перебивают армию;
 *  - найм размера с первого раунда (sizeHireMode 'early').
 * После армейской фазы — прежний профиль с множителями бонуса.
 */
export const getBotProfile = (state, player) => {
  const profile = getArchetypeProfile(getBotStrategy(player.id).archetype);
  const bonusProfile = getBotBonusProfile(player, selectGameType(state));

  if (!bonusProfile) {
    return profile;
  }

  const isArmyPhase = bonusProfile.strongCities && isBonusArmyPhase(selectRound(state));

  // Новый объект: профили архетипов — общие константы, править их нельзя
  return {
    ...profile,
    military: profile.military * bonusProfile.militaryMultiplier,
    captureEagerness: (isArmyPhase
      ? Math.max(profile.captureEagerness, bonusProfile.armyPhaseCaptureEagernessMin)
      : profile.captureEagerness) * bonusProfile.captureMultiplier,
    ...(isArmyPhase ? {
      keyPoint: profile.keyPoint * bonusProfile.armyPhaseKeyPointFactor,
      expansionRadius: null,
      sizeHireMode: 'early',
    } : {}),
  };
};
